import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { i18nReducer } from 'react-redux-i18n';

// Custom Reducers.
import error from 'reducers/error';
import alert from 'reducers/alert';
import config from 'reducers/config';
import auth from 'reducers/auth';
import jwtauth from 'reducers/jwtauth';
import profile from 'reducers/profile';
import dataSources from 'reducers/dataSources';
import dataSourcesCategories from 'reducers/dataSourcesCategories';
import dataSourcesTypes from 'reducers/dataSourcesTypes';
import statsTable from 'reducers/statsTable';
import coupons from 'reducers/coupons';
import payProducts from 'reducers/payProducts';
import payUser from 'reducers/payUser';
import payHistory from 'reducers/payHistory';
import cancelPayConnectedPackages from 'reducers/cancelPayConnectedPackages';
import payConnectedPackages from 'reducers/payConnectedPackages';
import dashboardDatePicker from 'reducers/dashboardDatePicker';
import lmsCourses from 'reducers/lmsCourses';
import lmsMaterials from 'reducers/lmsMaterials';
import lmsMaterial from 'reducers/lmsMaterial';
import shareDashboard from 'reducers/shareDashboard';
import charts from 'reducers/charts';
import chartsFlow from 'reducers/chartsFlow';
import chartsFlowHaveData from 'reducers/chartsFlowHaveData';
import chartsData from 'reducers/chartsData';
import chartsCategories from 'reducers/chartsCategories';
import archive from 'reducers/archive';
import oauth2AuthorizeIfttt from 'reducers/oauth2AuthorizeIfttt';
import consents from 'reducers/consents';

const appReducer = combineReducers({
  router: routerReducer,
  i18n: i18nReducer,
  alert,
  error,
  config,
  auth,
  jwtauth,
  profile,
  dataSources,
  dataSourcesCategories,
  dataSourcesTypes,
  statsTable,
  coupons,
  payProducts,
  payUser,
  payHistory,
  cancelPayConnectedPackages,
  payConnectedPackages,
  dashboardDatePicker,
  lmsCourses,
  lmsMaterials,
  lmsMaterial,
  shareDashboard,
  charts,
  chartsFlow,
  chartsFlowHaveData,
  chartsCategories,
  chartsData,
  archive,
  oauth2AuthorizeIfttt,
  consents,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
